// IMPORT SERVICES
import { CBService } from "../services/api";
const api = new CBService()

// IMPORT CUSTOM LIBRARIES
import TriggerAnimation from '../components/triggerAnimation';
import Recipes, { Filter } from '../components/recipes';

// IMPORT SWIPERS
import Swiper, { Navigation, Pagination, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";

let pathWrapper = document.querySelector('[data-path-theme]') as HTMLElement
let pathTheme = pathWrapper ? pathWrapper.dataset.pathTheme : ''

declare global {
    interface Window {
        dataLayer: any;
    }
}

let recipeCards: Recipes;

export const loadSwipers = async () => {
    let recipeSwiper = loadRecipeSwiper()

    try {
        let response: any = await api.getRecipes()

        // Carga el filtro de las ubicaciones
        new Filter('#locationSwiper .swiper-wrapper', {
            filterList: ['Todos', ...response.categories],
            createElement: (props: any) => {
                return `
                <div class="swiper-slide">
                <span class="cp-location-tab" data-filter-location="${props}">${props}</span>
                </div>`
            },
            onCreated: () => LoadLocationSwiper()
        })

        // Carga el filtro de las categorias
        new Filter('#categorySwiper .swiper-wrapper', {
            filterList: [{ name: 'Todos', img: `${pathTheme}/sources-meals-f2/dist/assets/images/icons/club.svg` }, ...response.subcategories],
            createElement: (props: any) => {
                return `
                <div class="swiper-slide">
                    <div class="cp-recipe-category" data-filter-category="${props.name}">
                        <img class="cp-recipe-category__image lazyload" data-src="${props.img}" alt="" title="" width="40" height="40">
                        <span class="cp-recipe-category__text">${props.name}</span>
                    </div>
                </div>`
            },
            onCreated: () => loadCategorySwiper()
        })

        // Carga las recetas y la funcionalidad del buscador
        recipeCards = new Recipes('#recipeSwiper .swiper-wrapper', {
            seeker: '#recipesSeeker',
            on: {
                update: () => recipeSwiper?.update()
            }
        })

    } catch (error) {
        console.log('error:', error);
    }

    loadCanSwiper()
    loadTourSwiper()
}

// CHAPTER LIST SWIPER
export function loadChapterSwiper() {
    new Swiper('#chapterSwiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        navigation: {
            disabledClass: 'swiper-chapter-button-disabled',
            prevEl: '.swiper-chapter-button-prev',
            nextEl: '.swiper-chapter-button-next',
        },
        pagination: {
            el: '.swiper-pagination'
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 60
            }
        }
    })
}

// BEER SWIPER
function loadCanSwiper() {
    new Swiper('#canSwiper', {
        modules: [Pagination],
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination'
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            991: {
                slidesPerView: 3
            }
        }
    })
}

// CHAPTER SWIPER
function loadTourSwiper() {
    new Swiper('#tourChapterSwiper', {
        modules: [Navigation, Pagination, EffectFade],
        effect: 'fade',
        speed: 1000,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.swiper-pagination'
        },
        navigation: {
            disabledClass: 'tour-button-disabled',
            prevEl: '.tour-button-prev',
            nextEl: '.tour-button-next'
        },
        on: {
            lock() {
                document.querySelector('.tour-swiper-message')?.classList.add('tour-swiper-message--hide')
            }
        }
    })
}

// LOCATION SWIPER
function LoadLocationSwiper(): void {
    let locationActive: number = 0;
    let locationTabsContainer: any = document.querySelector('#locationSwiper')
    let locationTabs: any = document.querySelectorAll('.cp-location-tab')

    new Swiper('#locationSwiper', {
        slidesPerView: 'auto',
        spaceBetween: 50,
        slideToClickedSlide: true,
        centerInsufficientSlides: true,
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 50,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 100,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 100,
            }
        },
        on: {
            init() {
                locationTabs[locationActive]?.classList.add('cp-location-tab--active')
            },
            activeIndexChange(e: any) {
                toggleActiveClass({
                    tabConfigurations: { nwTab: e.activeIndex, activeClass: 'cp-location-tab--active', tabList: locationTabs },
                    filter: { type: 'category', value: locationTabs[e.activeIndex].dataset.filterLocation }
                })
            }
        }
    })

    locationTabsContainer?.addEventListener('click', (e: any) => {
        if (e.target.classList.contains('cp-location-tab')) {
            if (!e.target.classList.contains('cp-location-tab--active')) {
                toggleActiveClass({
                    tabConfigurations: { nwTab: e.target, activeClass: 'cp-location-tab--active', tabList: locationTabs },
                    filter: { type: 'category', value: e.target.dataset.filterLocation }
                })
            }
        }
    })

    new TriggerAnimation('.cp-location-tab', {
        mobile: {
            from: { translateX: 50, opacity: 0 },
            to: { translateX: 0, stagger: 0.2, scrollTrigger: { trigger: '#locationSwiper' } }
        }
    }).triggerAnimation()
}

// CATEGORY SWIPER
function loadCategorySwiper(): void {
    let categoryActive: number = 0;
    let categoryTabsContainer: any = document.querySelector('#categorySwiper')
    let categoryTabs: any = document.querySelectorAll('.cp-recipe-category')

    new Swiper('#categorySwiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 3,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        slideToClickedSlide: true,
        navigation: {
            disabledClass: 'category-button-disabled',
            prevEl: '.category-button-prev',
            nextEl: '.category-button-next',
        },
        breakpoints: {
            640: {
                slidesPerView: 'auto',
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 40
            }
        },
        on: {
            activeIndexChange(e: any) {
                toggleActiveClass({
                    tabConfigurations: { nwTab: e.activeIndex, activeClass: 'cp-recipe-category--active', tabList: categoryTabs },
                    filter: { type: 'subcategory', value: categoryTabs[e.activeIndex].dataset.filterCategory }
                })
            }
        }
    })

    categoryTabsContainer?.addEventListener('click', (e: any) => {
        if (e.target.closest('.cp-recipe-category')) {
            let wrapperElement = e.target.closest('.cp-recipe-category')
            if (!wrapperElement.classList.contains('cp-recipe-category--active')) {
                toggleActiveClass({
                    tabConfigurations: { nwTab: wrapperElement, activeClass: 'cp-recipe-category--active', tabList: categoryTabs },
                    filter: { type: 'subcategory', value: wrapperElement.dataset.filterCategory }
                })
            }
        }
    })

    new TriggerAnimation('.cp-recipe-category', {
        mobile: {
            from: { translateX: 30, opacity: 0 },
            to: { translateX: 0, stagger: 0.2, scrollTrigger: { trigger: '#categorySwiper' } }
        },
        desktop: {
            to: { stagger: 0.1, scrollTrigger: { trigger: '#categorySwiper' } }
        }
    }).triggerAnimation()
}

// RECIPE SWIPER
export function loadRecipeSwiper() {
    const recipeSwiper = new Swiper('#recipeSwiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 26,
        centerInsufficientSlides: true,
        navigation: {
            disabledClass: 'list-button-disabled',
            prevEl: '.list-button-prev',
            nextEl: '.list-button-next',
        },
        pagination: {
            el: '.swiper-pagination'
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            991: {
                slidesPerView: 3
            },
            1367: {
                slidesPerView: 4
            }
        }
    })
    return recipeSwiper
}

// FUNCIONALIDAD PARA ALTERNAR CLASE DE LOS TABS (MODIFICADOR 'active')
interface TabConfig {
    nwTab: number | HTMLElement;
    activeClass: string;
    tabList: Array<any>;
}
interface TypeFilter {
    type: 'category' | 'subcategory';
    value: string;
}
interface ToggleParams {
    tabConfigurations: TabConfig;
    filter: TypeFilter;
}

function toggleActiveClass({ tabConfigurations, filter }: ToggleParams) {
    let { nwTab, activeClass, tabList } = tabConfigurations;
    let { type, value } = filter;

    if (value.toLocaleLowerCase() == 'todos') value = ''

    // ENVIA DATALAYER
    sendDataLayer(value, type)

    // FILTRA LAS RECETAS
    recipeCards?.updateRecipes({ type, value })

    // ACTIVA O DESACTIVA LOS TABS
    document.querySelector(`.${activeClass}`)?.classList.remove(activeClass)

    if (typeof nwTab === 'number') tabList[nwTab]?.classList.add(activeClass)
    else nwTab.classList.add(activeClass)
}

function sendDataLayer(category: string, type: string) {
    window.dataLayer = window.dataLayer || [];
    let layer =
        type == 'category' ?
            {
                'event': 'GAEvent',
                'event_category': 'Inicio',
                'event_action': 'Button',
                'event_label': category,
                'interaction': 'true',
                'component_name': 'button_TA DA',
                'element_text': 'TA DA'
            } :
            {
                'event': 'GAEvent',
                'event_category': 'Tipo de parrilla',
                'event_action': 'Card',
                'event_label': category,
                'interaction': 'true',
                'component_name': 'Card_Tipo de parrilla',
                'element_text': category
            }
    window.dataLayer.push(layer);
}
